import React, { FC } from 'react';
import styled from 'styled-components';
import { ErrorMessage, ErrorMessageProps } from 'formik';
import { typeHelpers } from '@polymathnetwork/new-shared';
import { formError } from '~/styles/utils';
import { Context } from '../Context';

export interface Props extends typeHelpers.Omit<ErrorMessageProps, 'name'> {}

const StyledError = styled.span`
  ${formError};
  margin-top: 0.25rem;
  float: left;
  margin-right: 0.5rem;

  &:last-child {
    margin-right: 0;
  }
`;

export const InputError: FC<Props> = props => (
  <Context.Consumer>
    {({ name }) => (
      <ErrorMessage component={StyledError} name={name} {...props} />
    )}
  </Context.Consumer>
);
try {
    // @ts-ignore
    InputError.displayName = "InputError";
    // @ts-ignore
    InputError.__docgenInfo = { "description": "", "displayName": "InputError", "props": { "className": { "defaultValue": null, "description": "", "name": "className", "required": false, "type": { "name": "string" } }, "component": { "defaultValue": null, "description": "", "name": "component", "required": false, "type": { "name": "string | ComponentClass<{}, any> | FunctionComponent<{}>" } }, "render": { "defaultValue": null, "description": "", "name": "render", "required": false, "type": { "name": "(errorMessage: string) => ReactNode" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/FormItem/InputError/index.tsx#InputError"] = { docgenInfo: InputError.__docgenInfo, name: "InputError", path: "src/components/FormItem/InputError/index.tsx#InputError" };
}
catch (__react_docgen_typescript_loader_error) { }